import { render } from "./RoomServiceOutline.vue.js?vue&type=template&id=813d9508!=!../vue-loader/dist/index.js??ruleSet[0]!./RoomServiceOutline.vue?vue&type=template&id=813d9508"
import script from "./RoomServiceOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./RoomServiceOutline.vue?vue&type=script&lang=js"
export * from "./RoomServiceOutline.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./RoomServiceOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__